import { Spinner } from 'components/spinner'
import type { FunctionalComponent, MaybeRef } from 'vue'
import { unref } from 'vue'
import { computed, defineComponent } from 'vue'

export const WizardWrapper = defineComponent<{
  banner?: {
    component: FunctionalComponent<any>
  }
  loadingState?: FunctionalComponent<any>
  stepIndex?: MaybeRef<number>
  isLoading?: MaybeRef<boolean>
  progress?: MaybeRef<number>
  simple?: MaybeRef<boolean>
  minWidth?: MaybeRef<number>
  maxWidth?: MaybeRef<number>;
  withPadding?: MaybeRef<boolean>;
}>(
  (props, { slots }) => {
    const isLoading = computed(() => !!unref(props.isLoading))
    const isSimple = computed(() => !!unref(props.simple) || isLoading.value)

    return () => {
      return (
        <div
          class="grow flex flex-col items-center w-full relative p-4"
          style={{
            ...(isLoading.value
              ? {
                  maxHeight: '100svh',
                  overflow: 'hidden'
                }
              : {})
          }}
        >
          <div
            class={`w-full max-w-screen md:max-w-[862px] flex items-center justify-center`}
          >
            {props.banner && <props.banner.component />}
          </div>
          <div
            class={[`w-full max-w-screen md:max-w-[862px]`, isSimple.value ? '' : 'border border-gray-300 py-6 px-4 md:py-8 md:px-9']}
          >
            <div
              style={{
                ...(isLoading.value && props.loadingState
                  ? {
                      display: 'none',
                      position: 'fixed',
                      top: '0px',
                      left: '0px',
                      height: '0px',
                      width: '0px',
                      minHeight: '0px',
                      minWidth: '0px'
                    }
                  : {})
              }}
            >
              {slots.default ? slots.default() : ''}
            </div>
          </div>
          {isLoading.value ? (
            props.loadingState ? (
              <props.loadingState />
            ) : (
              <div class="w-full h-full absolute top-0 left-0 flex items-center justify-center">
                <Spinner />
              </div>
            )
          ) : null}
        </div>
      )
    }
  },
  {
    props: [
      'banner',
      'stepIndex',
      'isLoading',
      'simple',
      'minWidth',
      'maxWidth',
      'loadingState',
      'progress',
      'withPadding'
    ]
  }
)
